// extracted by mini-css-extract-plugin
export default {"MobilePersonalizeLayersContent":"MobilePersonalizeLayersContent_MobilePersonalizeLayersContent__w+Akj","content":"MobilePersonalizeLayersContent_content__ujWhw"};